import { Accessor, Setter, createContext, createSignal, useContext } from "solid-js"
import { AccordionProps } from "./st-accordion";

export class AccordionContext {
    expandedIds: Accessor<string[]>; private setExpandedIds: Setter<string[]>
    multiple: Accessor<boolean>; private setMultiple: Setter<boolean>

    constructor() {
        [this.expandedIds, this.setExpandedIds] = createSignal<string[]>([]);
        [this.multiple, this.setMultiple] = createSignal<boolean>(false);
    }

    receiveProps(props: AccordionProps) {
        this.setMultiple(props.multiple ?? this.multiple());
    }

    toggle(id: string) {
        const ids = this.expandedIds();
        if (this.multiple()) {
            if (ids.includes(id)) {
                this.setExpandedIds(ids.filter(i => i !== id));
            } else {
                this.setExpandedIds([...ids, id]);
            }
        } else {
            if (ids.includes(id)) {
                this.setExpandedIds([]);
            } else {
                this.setExpandedIds([id]);
            }
        }
    }

    open(id: string) {
        const ids = this.expandedIds();
        if (ids.includes(id)) return;
        
        if (this.multiple()) {
            if (!ids.includes(id)) {
                this.setExpandedIds([...ids, id]);
            }
        }
        if (!ids.includes(id)) {
            this.setExpandedIds([...ids, id]);
        }
    }

    close(id: string) {
        const ids = this.expandedIds();
        if (ids.includes(id)) {
            this.setExpandedIds(ids.filter(i => i !== id));
        }
    }

}

const _Context = createContext<AccordionContext>();

export const useAccordion = () => {
    const ctx = useContext(_Context);

    if (!ctx) {
        throw new Error("useAccordion must be used within an Accordion component");
    }

    return ctx;
}

export const AccordionProvider = _Context.Provider;